import { atom } from "recoil";

// 削除する際に必要なID
export const deleteIdStore = atom<string>({
  key: "deleteIdStoreData",
  default: "",
});
